import RequestBuilder from '../Lib/Requests';

export default class UtilizationService {
  api = new RequestBuilder();

  buildRunGatewayOutputSignalsRequest(gatewayID, params, cancelToken) {
    return {
      cancelToken,
      endpoint: `/v1/utilization/gateway/${gatewayID}`,
      method: 'post',
      params,
      service: 'utilization',
    };
  }
  runGatewayOutputSignals(gatewayID, params, cancelToken) {
    return this.api.request(
      this.buildRunGatewayOutputSignalsRequest(gatewayID, params, cancelToken)
    );
  }
}
